import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { SEARCH_KEY } from '../../_shared/constants/search';
import useEscModalTrack from '../../_shared/hooks/useEscModalTracking';
import Carousel from '../../pages/RetailVdp/Carousel';

import { GalleryContainer, Gallery, Close } from './Styles';

const LightboxGallery = ({
  isOpen,
  setIsGalleryOpen,
  media,
  selectedPhotoIdx,
  retailTrade,
  tradeDetails,
  dealerName
}) => {
  useEscModalTrack('Retail VDP Gallery', isOpen);

  useEffect(() => {
    const escHandler = event => {
      if (event.keyCode === SEARCH_KEY.ESC) {
        setIsGalleryOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', escHandler);
    } else {
      document.removeEventListener('keydown', escHandler);
    }
    return () => document.removeEventListener('keydown', escHandler);
  }, [isOpen, setIsGalleryOpen]);

  return (
    <GalleryContainer isOpen={isOpen}>
      <Gallery>
        <Close
          onClick={() => setIsGalleryOpen(false)}
          data-testid="retailGallery-close"
        >
          <FormattedMessage id="list.nav.searchbar.modal.closeButton" />
          <Close.Icon />
        </Close>
        <Carousel
          media={media}
          isLightbox
          selectedPhotoIdx={selectedPhotoIdx}
          retailTrade={retailTrade}
          tradeDetails={tradeDetails}
          dealerName={dealerName}
        />
      </Gallery>
    </GalleryContainer>
  );
};

export default LightboxGallery;
